// src/Components/AIImageUploader/AIImageUploader.js

import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import './AIImageUploader.css';

const AIImageUploader = ({ setIsAiProcessing, isAiProcessing, onAnalysisComplete, aiImageFile, setAiImageFile }) => {
    const [preview, setPreview] = useState(null);

    // useEffect, ki posodobi predogled, ko se datoteka spremeni
    useEffect(() => {
        if (!aiImageFile) {
            setPreview(null);
            return;
        }
        const objectUrl = URL.createObjectURL(aiImageFile);
        setPreview(objectUrl);

        // Počistimo, ko se komponenta uniči
        return () => URL.revokeObjectURL(objectUrl);
    }, [aiImageFile]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setAiImageFile(file);
        }
    };

    const handleAnalyzeClick = async () => {
        if (!aiImageFile) {
            Swal.fire("Napaka", "Prosimo, izberite sliko za analizo.", "error");
            return;
        }

        setIsAiProcessing(true);
        const formData = new FormData();
        formData.append('image', aiImageFile);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/listings/analyze-image`, {
                method: 'POST',
                credentials: 'include',
                body: formData,
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Neznana napaka na strežniku.');
            }

            const data = await response.json();
            onAnalysisComplete(data);

        } catch (error) {
            Swal.fire("Napaka pri analizi", error.message, "error");
        } finally {
            setIsAiProcessing(false);
        }
    };

    return (
        <div className="ai-uploader-wrapper">
            <h5 className="ai-uploader-title">1. korak: Naloži sliko izdelka</h5>
            <p className="ai-uploader-subtitle">Naša umetna inteligenca bo prepoznala izdelek in samodejno izpolnila podatke o oglasu.</p>

            <div className="ai-uploader-box" onClick={() => document.getElementById('ai-file-input').click()}>
                <input
                    type="file"
                    id="ai-file-input"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                    accept="image/*"
                />
                {preview ? (
                    <img src={preview} alt="Predogled" className="ai-image-preview" />
                ) : (
                    <div className="ai-uploader-placeholder">
                        <p>Klikni za izbiro slike</p>
                        <span role="img" aria-label="picture">🖼️</span>
                    </div>
                )}
            </div>

            <button
                //  Dodali smo pogojni razred 'analyzing'
                className={`btn btn-success mt-4 w-100 analyze-btn ${isAiProcessing ? 'analyzing' : ''}`}
                onClick={handleAnalyzeClick}
                disabled={!aiImageFile || isAiProcessing}
            >
                {isAiProcessing ? (
                    <>
                        <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '8px' }}></i>
                        Analiziram...
                    </>
                ) : (
                    <>
                        Analiziraj sliko <i className="fa-solid fa-wand-magic-sparkles" style={{ marginLeft: '8px' }}></i>
                    </>
                )}
            </button>
        </div>
    );
};

export default AIImageUploader;